import {
  Card, CardBody, Flex, Icon,
  Skeleton,
  Stat,
  StatHelpText,
  StatLabel,
  StatNumber,
} from '@chakra-ui/react';
import IconBox from '../../Components/Icons/IconBox';

const DashboardCard = ({
  title, isFetching, value, helper, icon,
}) => (
  <Card minH="125px">
    <CardBody>
      <Flex direction="row">
        <Stat me="auto">
          <StatLabel
            fontSize="xs"
            color="gray.400"
            fontWeight="bold"
            textTransform="uppercase"
          >
            {title}
          </StatLabel>
          <>
            <StatNumber fontSize="lg" fontWeight="bold">
              { isFetching ? <Skeleton height="20px" my="1" w="25px" /> : value}
            </StatNumber>
            <StatHelpText color="gray.400" fontSize="sm" mt="4" mb="0">
              { isFetching ? <Skeleton height="20px" mt="5" /> : helper }
            </StatHelpText>
          </>
        </Stat>
        <IconBox
          borderRadius="50%"
          h="45px"
          w="45px"
          bg="blue.500"
        >
          <Icon as={icon} h="20px" w="20px" color="white" />
        </IconBox>
      </Flex>
    </CardBody>
  </Card>
);

export default DashboardCard;
